import { useBodyClass } from '@/hooks/useBodyClass';

interface BodyClassManagerProps {
  className: string;
  enabled: boolean;
}

export function BodyClassManager({ className, enabled }: BodyClassManagerProps) {
  useBodyClass(className, enabled);
  return null;
}
